class EInvoicingSignPaymentRequest {
    /**
     * @param {string} externalID
     * @param {string} totalAmount
     * @param {string} totalVatAmount
     * @param {string} totalNetAmount
     * @param {number} totalPaymentAmount
     * @param {string} terminalID
     * @param {string} documentNumber
     * @param {string} documentNumberSeries
     * @param {string} myDataType
     */
    constructor(
        externalID,
        totalAmount,
        totalVatAmount,
        totalNetAmount,
        totalPaymentAmount,
        terminalID,
        documentNumber,
        documentNumberSeries,
        myDataType
    ) {
        this.externalID = externalID;
        this.totalAmount = totalAmount;
        this.totalVatAmount = totalVatAmount;
        this.totalNetAmount = totalNetAmount;
        this.totalPaymentAmount = totalPaymentAmount;
        this.terminalID = terminalID;
        this.documentNumber = documentNumber;
        this.documentNumberSeries = documentNumberSeries;
        this.myDataType = myDataType;
    }
}

module.exports = EInvoicingSignPaymentRequest;
